import { PropsWithChildren } from 'react';
import { DivProps } from './common-types';
import { cn } from 'domain/core';

export const Container = (props: PropsWithChildren<DivProps>) => {
	const { className, children, ...rest } = props;
	return (
		<div
			className={cn(
				'flex h-screen w-screen flex-col items-center justify-center bg-neutral-200',
				className
			)}
			{...rest}>
			{children}
		</div>
	);
};
